import config, { SERVER_PREFIXES } from '@app/config'

export const getSsoUrl = (ssoInfo: LoginSsoResponse): string => {
  const url_referrer =
    config.ENV === 'dev' ? ssoInfo.url_referrer.replace(SERVER_PREFIXES.re7, 'localhost:3000') : ssoInfo.url_referrer
  return `${ssoInfo.url}?service_name=${ssoInfo.service_name}&url_referrer=${url_referrer}`
}
